<template>
    <el-menu :default-active="$route.path" class="el-menu-vertical" text-color="inherit"
        active-text-color="#409EFF" router >
        <template v-for="item in routes">
            <!-- 一级菜单 -->
            <el-menu-item v-if="!item.children" :index="item.path" :key="item.path">
                <i :class="item.icon"></i>
                <span slot="title">{{ item.name }}</span>
            </el-menu-item>

            <!-- 有子菜单的一级菜单 -->
            <el-submenu v-if="item.children && item.children.length > 0" :index="item.path" :key="item.path">
                <template slot="title">
                    <i :class="item.icon"></i>
                    <span>{{ item.name }}</span>
                </template>
                <el-menu-item v-for="child in item.children" :key="item.path+ '/' + child.path" :index="child.path">
                    <i :class="child.icon"></i>
                    {{ child.name }}
                </el-menu-item>
            </el-submenu>
        </template>
    </el-menu>
</template>

<script>
export default {
    name: 'Sidebar',
    computed: {
        routes() {
            try {
                const raw = localStorage.getItem('route');
                const parsed = raw ? JSON.parse(raw) : [];
                return Array.isArray(parsed) ? parsed : [];
            } catch (e) {
                return [];
            }
        }
    }
}
</script>